import { gql } from '@apollo/client';

export const RetryUpload = gql`
    mutation retryUpload($knowledgeDataId: ID!) {
        retryUpload(knowledgeDataId: $knowledgeDataId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
